import React, { useEffect, useState } from 'react';
import { getFollowups } from '../services/api';

export default function Followup() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    getFollowups().then(r => setItems(r.data.followups)).catch(() => {});
  }, []);

  return (
    <div>
      <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 6, color: '#212529' }}>Follow-up Queue</h1>
      <p style={{ color: '#6c757d', fontSize: 13, marginBottom: 24 }}>Customers with no contact info that need follow-up</p>

      <div style={{ background: '#ffffff', border: '1px solid #dee2e6', borderRadius: 14, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #dee2e6' }}>
              {['Order', 'Customer', 'Attempts', 'Deadline', 'Status', 'Action'].map(h => (
                <th key={h} style={{ padding: '11px 16px', textAlign: 'left', fontSize: 11, fontWeight: 600, color: '#6c757d', textTransform: 'uppercase' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {items.map(f => (
              <tr key={f.id} style={{ borderBottom: '1px solid #e9ecef', background: f.is_overdue ? '#ef444408' : 'transparent' }}>
                <td style={{ padding: '11px 16px', fontSize: 12, color: '#a78bf8', fontFamily: 'monospace' }}>#{f.order_id}</td>
                <td style={{ padding: '11px 16px', fontSize: 13 }}>Customer #{f.customer_id}</td>
                <td style={{ padding: '11px 16px', fontSize: 13, textAlign: 'center' }}>{f.attempts}</td>
                <td style={{ padding: '11px 16px', fontSize: 13, color: f.is_overdue ? '#ef4444' : '#212529', fontWeight: f.is_overdue ? 700 : 400 }}>{f.followup_deadline}</td>
                <td style={{ padding: '11px 16px' }}>
                  <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 20, background: f.is_overdue ? '#ef444420' : '#f59e0b20', color: f.is_overdue ? '#ef4444' : '#f59e0b' }}>
                    {f.is_overdue ? 'OVERDUE' : 'Pending'}
                  </span>
                </td>
                <td style={{ padding: '11px 16px' }}>
                  <button style={{ background: '#7c6af5', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>Send DM</button>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={6} style={{ padding: 24, textAlign: 'center', color: '#22c55e' }}>✅ No pending follow-ups!</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}